import { apiClient } from '../api/apiClient';

export interface ProfileData {
  _id: string | null;
  user: {
    currentCompanyInfo: {
      companyname: string;
      addressLine1: string;
      addressLine2: string;
      city: string;
      state: string;
      pincode: string;
    };
    jobPreferences: {
      currentSalary: {
        max: number;
        currency: string;
        denomination: string;
        period: string;
      };
      expectedSalary: {
        max: number;
        currency: string;
        denomination: string;
        period: string;
      };
      jobTitle: string;
      jobDescription: string;
      jobType: string;
      experienceLevel: string;
      workMode: string;
      noticeType: string;
      skills: string[];
      location: string[];
      resumeId?: {
        _id:string;
        originalName:string;
        url:string;
        mimeType:string
      }
    };
    _id: string;
    email: string;
    name: string;
    designation: string;
    city: string;
    state: string;
    whatsappNumber: string;
    isWhatsappVerified: boolean;
    socialMediaLinks: any[];
    profilePictureId: {
      _id: string;
      originalName: string;
      url: string;
      mimeType: string;
      size: number;
    };
    gender: string;
    role: string;
    isEmailVerified: boolean;
    loginAttempts: number;
    isActive: boolean;
    membershipTier: string;
    createdAt: string;
    updatedAt: string;
    userId: string;
    aboutMe: string;
    address: string;
    dateOfBirth: string;
    isLookingForJob: boolean;
    pincode: string;
  };
  profileCompletionPercentage: number;
  stats: {
    feedCount: number;
    followersCount: number;
    followingCount: number;
  };
  relationshipStatus: {
    isFollowing: boolean;
    hasRequestPending: boolean;
    isRequestSent:boolean;
  };
}

export interface ProfileResponse {
  success: boolean;
  message: string;
  data: {
    profile: ProfileData;
  };
}

class ProfileService {
  async getProfile(userId: string): Promise<ProfileResponse> {
    const response = await apiClient.get<ProfileResponse>(`/profile/${userId}`);
    return response;
  }
}

export const profileService = new ProfileService();